import { tw } from '@/utils/tw';

const Main = tw.theme({
  base: ['group/main', 'mx-auto', 'max-w-grid', 'w-full'],
});

export default Main;
